import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { backend } from 'modules/data';

// Created and unsaved requests are considered non-modified; all others are considered modified.
export const isModifiedRequestState = atom(true);

export const customGetRequestTransferState = atomWithReset<
    (() => backend.Transfer<backend.transfers.RequestEditTransfer>) | undefined
>(undefined);

export const customRequestValidationFnState = atomWithReset<(() => string[]) | undefined>(undefined);

export const customSaveAndSubmitRequestState = atomWithReset<
    ((commentText?: string, needToCompleteReview?: boolean) => void) | undefined
>(undefined);

export const customIsSavingSaveAndSubmitRequestState = atomWithReset<boolean>(false);
